var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_48688_14029)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.996 12.7045C23.996 18.7653 19.5047 23.7758 13.6702 24.5889C13.1247 24.6646 12.5665 24.7041 11.9999 24.7041C11.346 24.7041 10.7038 24.652 10.0784 24.5511C4.36656 23.6312 0.00390625 18.677 0.00390625 12.7045C0.00390625 6.07705 5.37527 0.704102 12.0008 0.704102C18.6263 0.704102 23.9977 6.07705 23.9977 12.7045H23.996Z",
    fill: "#1C1C1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.51256 8.1416C11.0048 8.1416 13.025 10.1759 13.025 12.6851C13.025 15.1944 11.0046 17.2285 8.51256 17.2285C6.02049 17.2285 4 15.1944 4 12.6851C4 10.1759 6.02033 8.1416 8.51256 8.1416ZM15.7188 8.40775C16.9649 8.40775 17.9751 10.3226 17.9751 12.6851H17.9752C17.9752 15.047 16.9651 16.9625 15.7189 16.9625C14.4728 16.9625 13.4627 15.047 13.4627 12.6851C13.4627 10.3232 14.4727 8.40775 15.7188 8.40775ZM19.2065 8.85327C19.6446 8.85327 20 10.5688 20 12.6851C20 14.8008 19.6448 16.517 19.2065 16.517C18.7681 16.517 18.4131 14.8013 18.4131 12.6851C18.4131 10.569 18.7683 8.85327 19.2065 8.85327Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_48688_14029"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.704102)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.c8e42f84dd8b819611e24bf52a81ef9d.svg";
export { ForwardRef as ReactComponent };